<template lang="pug">
  .wrapper-hour-bank-rules-details
    h2 {{ id ? `editar`: 'nova' }} regra de banco de horas
    .form-new
      Validate.name(useState="timeoff/details/name" :minLength="3")
        PTextField(
          name="name"
          v-focus
          label="nome da regra de banco de horas"
        )
      Validate.date-of-banco(useState="timeoff/details/dateOfBancoStart" :required="!rollingWorkHoursBank")
        PDatePicker(
          name="date-of-banco"
          label="data de início do banco"
        )
      Validate.number-of-days-to-compensation(
        useState="timeoff/details/numberOfDaysToCompensation"
        :max="isLar21 ? null : 600"
      )
        PTextField(
          label="limite de acúmulo do banco (dias):"
          type="number"
        )
      .time-count-type
        span tipo de contagem de tempo:
        .radios
          PRadio(label="por data (fixo)" useState="timeoff/details/timeCountType" option="fixo")
          PRadio(label="por evento (movel)" useState="timeoff/details/timeCountType" option="movel")
      .code
        PTextField(
          name="code"
          v-focus
          label="código"
          useState="timeoff/details/code"
        )
      .slider
        CompensationPerHourKind
        PCheckbox(
          label="customizar percentual de acúmulo"
          useState="timeoff/details/accPerc"
        )
        SplitPerKindOfHour(v-if="accPerc")
        PCheckbox(
          label="limite de acúmulo diário"
          useState="timeoff/details/accDailyLimit"
        )
        DailyCheck(v-if="accDailyLimit")
        PCheckbox(
          label="limite de acúmulo mensal"
          useState="timeoff/details/accMonthlyLimit"
        )
        MonthlyCheck(v-if="accMonthlyLimit")
        PCheckbox(
          label="limite de acúmulo geral"
          useState="timeoff/details/accGeral"
        )
        GeneralCheck(v-if="accGeral")
      .compensation
        CompensationsConfig
      .button
        PButton(color="success" size="md" @click="save" :loading="saving") salvar

</template>

<script>
import CompensationsConfig from './CompensationsConfig'
import CompensationPerHourKind from './GeneralConfigs/CompensationPerHourKind'
import SplitPerKindOfHour from './GeneralConfigs/SplitPerKindOfHour'
import DailyCheck from './GeneralConfigs/DailyCheck'
import MonthlyCheck from './GeneralConfigs/MonthlyCheck'
import GeneralCheck from './GeneralConfigs/GeneralCheck'
import { Tabs, Tab } from 'src/common/Tabs'
import { useValidationsMixin } from 'src/common/validations'
import { mapState } from 'vuex'

export default {
  name: 'HourBankRulesDetails',
  props: {
    id: {type: String, required: false, default: null}
  },
  async created () {
    this.$store.commit('timeoff/details/resetState')
    if (this.id) {
      await this.$store.dispatch('timeoff/details/loadWhbRules', this.id)
    }
  },
  data () {
    return {
      saving: false,
      actualTab: 'Fator de transformação de horas'
    }
  },
  computed: {
    ...mapState('timeoff/details', ['loading', 'name', 'autoCompensate', 'timeCountType', 'accPerc', 'accDailyLimit', 'accMonthlyLimit', 'accGeral']),
    rollingWorkHoursBank () {
      return this.timeCountType === 'movel'
    },
    isLar21 () {
      return this.$store.state.userInfo.email.includes('lar21@')
    }
  },
  methods: {
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }
      this.saving = true

      try {
        await this.$store.dispatch('timeoff/details/save')

        let message = {}
        if (this.id) {
          message = {
            title: `Atualizar regra de banco de horas!`,
            text: `A regra de banco de horas ${this.name} foi atualizada com sucesso.`
          }
        } else {
          message = {
            title: `Nova regra de banco de horas!`,
            text: `A regra de banco de horas ${this.name} foi inserida com sucesso.`
          }
        }

        this.$swal({
          type: 'success',
          title: message.title,
          text: message.text
        })
        this.$router.push('/timeoff/list')
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : `Não foi possível salvar a regra`
        })
      }
      this.saving = false
    }
  },
  mixins: [useValidationsMixin({})],
  components: {
    CompensationsConfig,
    CompensationPerHourKind,
    SplitPerKindOfHour,
    DailyCheck,
    MonthlyCheck,
    GeneralCheck,
    Tabs,
    Tab
  },
  directives: {}
}
</script>

<style scoped lang="scss">
.wrapper-hour-bank-rules-details {
  display: grid;
  grid-template-rows: min-content auto;
  grid-template-columns: 1fr;

  h2 {
    text-align: center;
  }

  .form-new {
    grid-row: 2;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: 1fr .7fr 1fr .9fr 1fr;
    grid-template-rows: 1fr auto auto min-content;
    grid-column-gap: 30px;
    grid-row-gap: 20px;
    align-items: center;
    grid-template-areas:
      "name date-of-banco number-of-days-to-compensation time-count-type code"
      "slider slider slider slider slider"
      "compensation compensation compensation compensation compensation"
      ". . . . button";

    .name { grid-area: name; }
    .code { grid-area: code }
    .date-of-banco { grid-area: date-of-banco; }
    .number-of-days-to-compensation { grid-area: number-of-days-to-compensation }
    .time-count-type {
      grid-area: time-count-type;

      .radios {
        display: flex;
        & > * {
          margin-right: 15px;
        }
      }
    }
    .rolling-work-hours-bank { grid-area: rolling-work-hours-bank ; }
    .slider { grid-area: slider; }
    .compensation { grid-area: compensation; }
    .button { grid-area: button; justify-self: end;}
  }
}

.form-new .slider .wrapepr .tabs {
  width: 100% !important;
}
</style>
